import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal, CropMarks } from "@/components/atoms";
import { openCvRequest } from "@/components/CvRequest";

export const Contact = () => {
  const { t } = useLanguage();
  const c = t.contact;
  const links = t.links;
  return (
    <section id="kontakt" className="border-t border-hairline" data-testid="contact-section">
      <div className="px-5 md:px-10 py-24 md:py-36">
        <Reveal>
          <Chapter num={c.chapter} label={c.label} />
        </Reveal>
        <div className="mt-10 md:mt-14 flex items-end justify-between gap-8 md:gap-14">
          <Reveal delay={0.1} className="min-w-0">
            <h2 className="font-serif font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl md:text-7xl max-w-4xl" data-testid="contact-headline">
              {c.headline}
            </h2>
          </Reveal>
          {c.portraitSrc && (
            <Reveal delay={0.2} className="shrink-0">
              <div className="relative w-20 sm:w-24 md:w-32 aspect-[7/9] border border-ink/25 overflow-hidden bg-cardboard" data-testid="contact-portrait">
                <img src={c.portraitSrc} alt={c.portraitAlt || "Jo Lenz"} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                <CropMarks className="text-paper/70 z-10" />
              </div>
            </Reveal>
          )}
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-2 gap-px bg-hairline border border-hairline" data-testid="contact-routes">
          {c.routes.map((route, i) => (
            <Reveal key={route.key} delay={0.1 + i * 0.1} className="bg-paper">
              <div className={`p-8 md:p-12 h-full ${route.primary ? "relative" : ""}`} data-testid={`contact-route-${route.key}`}>
                {route.primary && <span className="absolute top-0 left-0 w-full h-[3px] bg-proof" aria-hidden="true" />}
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{route.label}</span>
                <p className="mt-5 font-serif font-light tracking-tight text-2xl md:text-3xl leading-snug">{route.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 md:mt-24">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">{c.emailLabel}</p>
            <a
              data-testid="contact-email-link"
              href={`mailto:${links.email}`}
              className="mt-4 inline-block font-serif font-light tracking-tighter leading-none text-[11vw] sm:text-6xl md:text-7xl lg:text-[6vw] link-underline break-all"
            >
              {links.email}
            </a>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke" data-testid="contact-location">
              {c.location}
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button
              data-testid="contact-cv-btn"
              onClick={openCvRequest}
              className="border border-ink px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] transition-colors duration-500 hover:bg-ink hover:text-paper"
            >
              {t.cv.requestLabel}
            </button>
            <a
              data-testid="contact-art-link"
              href={links.artUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="border border-ink/30 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke transition-colors duration-500 hover:border-ink hover:text-ink"
            >
              {c.artLabel} ↗
            </a>
            {links.instagramUrl && (
              <a
                data-testid="contact-instagram-link"
                href={links.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-ink/30 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke transition-colors duration-500 hover:border-ink hover:text-ink"
              >
                Instagram ↗
              </a>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
